import React from "react";
import LogoutContainer from "../containers/logout-container";

const LogoutPage = props => (
  <main className="logout-page">
    <LogoutContainer />
  </main>
);

export default LogoutPage;
